<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>群组控制</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-dropdown split-button
                     type="primary"
                     size="small"
                     @click="dialogVisible = true"
                     trigger="click">
          <span><i class="el-icon-upload2"></i> 上传群组门店关系</span>
          <el-dropdown-menu slot="default">
            <el-dropdown-item @click.native="downloadImportMarketGroupDemo">下载Demo文件</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-table
        :data="table"
        stripe
        highlight-current-row
        border
        style="width: 100%">
        <template v-for="attr of batchJobFields">
          <el-table-column v-if="attr.prop === 'display_name'" v-bind="attr">
            <template slot-scope="scope">
              <el-link type="text" @click="onDownSourceFile(scope.row.id)">{{scope.row.display_name}}</el-link>
            </template>
          </el-table-column>
          <el-table-column v-else v-bind="attr"></el-table-column>
        </template>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <button-gutter>
              <template v-if="scope.row.status === 3 && scope.row.error_count > 0">
                <el-button type="text"
                           size="mini"
                           @click="onDownErrorFile(scope.row.id)"
                           v-if="scope.row.error_count > 0 && !isConflictForceUpdated(scope.row)">
                  {{ Number(scope.row.task_type) === 51 ? '下载冲突项' : '下载错误行'  }}
                </el-button>
                <template v-if="Number(scope.row.task_type) === 51" >
                  <el-button type="text"
                             size="mini"
                             @click="retryMarketGroupRelationConflict(scope.row.id)"
                             v-if="scope.row.error_count > 0 && !scope.row.params.hasOwnProperty('conflict_state')">
                    执行冲突更新
                  </el-button>
                  <el-button type="text"
                             size="mini"
                             @click="giveupMarketGroupRelationConflict(scope.row.id)"
                             v-if="scope.row.error_count > 0 && !scope.row.params.hasOwnProperty('conflict_state')">
                    放弃冲突更新
                  </el-button>
                </template>
              </template>
            </button-gutter>
            <div v-if="isConflictForceUpdated(scope.row)"
                 style="color:#909399;font-size:12px;line-height:1.6;margin-top:4px;white-space:normal;word-break:break-all;">
              冲突文件已用于强制更新，请下载对应「群组门店关联(冲突处理)」任务的源文件
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination margin t10">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[10, 20, 30, 50]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <el-dialog title="上传门店群组关系"
               :visible.sync="dialogVisible">
      <el-form ref="uploadForm"
               label-width="140px"
               @submit.native.prevent="onSubmitUploadForm"
               :model="uploadForm">
        <el-form-item label="是否覆盖更新">
          <el-radio-group v-model="uploadForm.replace_update">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传excel文件" required>
          <el-upload
            ref="uploader"
            drag
            action=""
            accept=".xlsx"
            :limit="1"
            :http-request="uploadFile">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过5000kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit">提交表单</el-button>
          <el-button @click="resetUploadForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import batchjobsRequests from '@components/Batchjobs/api'
import groupBatchMixins from '../group-batch.mixins'
import downloadJS from 'downloadjs'

export default {
  mixins: [table, groupBatchMixins],
  components: {},
  data () {
    return {
      dialogVisible: false,
      search: {
        task_type: [51, 54],
        number: this.$route.params.customerid,
      },
      searchFieldType: {
        task_type: Array
      },
      uploadForm: {
        replace_update: false,
        file: null
      }
    }
  },
  computed: {
    relationProjectId () {
      return this.$route.params.projectid ? Number(this.$route.params.projectid) : 0
    },
  },
  methods: {
    getTableData (params) {
      return request.page('queryBatchUpload', filter.copyJson(params))
    },
    resetUploadForm () {
      filter.setLoop(this.uploadForm, {
        replace_update: false,
        file: null
      })
    },
    onSubmitUploadForm () {
      if (!this.uploadForm.file) {
        this.$message.error('请上传文件')
        return
      }

      let formData = new FormData()
      formData.append('file', this.uploadForm.file)
      formData.append('type', '51')
      formData.append('number', this.$route.params.customerid)
      formData.append('params[customer_id]', this.$route.params.customerid)
      formData.append('params[projectid]', this.relationProjectId)
      formData.append('params[replace_update]', Number(this.uploadForm.replace_update))

      request.common('importMarketGroupRelation', formData).then(() => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.dialogVisible = false
        this.resetUploadForm()
        this.$refs['uploader'].clearFiles()
        this.onRefresh()
      })
    },
    uploadFile (file) {
      let isLt10M = file.file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        return false
      }

      this.uploadForm.file = file.file
    },
    onDownSourceFile (id) {
      this.$confirm('确认下载文件?', '提示', {
        type: 'warning',
      }).then(() => {
        downloadJS(batchjobsRequests.downSourceFile({id: id}))
      })
    },
    onDownErrorFile (id) {
      this.$confirm('确认下载?', '提示', {
        type: 'warning',
      }).then(() => {
        downloadJS(batchjobsRequests.downErrorFile({id: id}))
      })
    },
    // conflict_state=2：已执行冲突更新，原冲突文件被挪作强制任务源文件
    isConflictForceUpdated (row) {
      return Number(row.task_type) === 51 && Number((row.params || {}).conflict_state) === 2
    },
    downloadImportMarketGroupDemo () {
      this.$export('上传群组门店关系', [
        {
          'market_id': '769389',
          'market_name': '永辉顺义区后沙峪店',
          'group_name_1': 'A群组',
          'group_name_2': 'B群组',
          'group_name_3': 'C群组',
          'group_name_4': '',
          'group_name_5': '',
        },
        {
          'market_id': '769388',
          'market_name': '屈臣氏平湖南城百货）',
          'group_name_1': 'A群组',
          'group_name_2': 'B群组',
          'group_name_3': '',
          'group_name_4': '',
          'group_name_5': '',
        },
        {
          'market_id': '温馨提示：【群组名称1】必填、【群组名称2~5】可不填；填写的名称不能重复',
        },
      ], {
        fileHeader: this.marketUploadDemoHeader
      })
    },
    retryMarketGroupRelationConflict (id) {
      this.$confirm('确认要执行冲突更新吗?', '提示').then(() => {
        request.common('retryMarketGroupRelationConflictApi', {id}).then(() => {
          this.onSearch({})
        })
      })
    },
    giveupMarketGroupRelationConflict (id) {
      this.$confirm('确认要放弃冲突更新吗?', '提示').then(() => {
        request.common('giveupMarketGroupRelationConflictApi', {id}).then(() => {
          this.onSearch({})
        })
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/group-batch/pages/GroupBatchMarketUploadTable.vue